import React from "react";
import { useNotify, usePermissions, useRedirect } from "react-admin";

import { FormCustomer } from "./FormCustomer";
import { FormTransporter } from "./FormTransporter";

export const FormCustomerTransporter = ({ isAddMode, initRecordData, ...props }) => {
	const redirect = useRedirect();
	const notify = useNotify();

	const { permissions } = usePermissions();
	if (!permissions) return null;

	if (initRecordData.multiValues["company_id"].every((_id) => permissions.company_id === _id)) {
		return <FormCustomer isAddMode={isAddMode} initRecordData={initRecordData} {...props} />;
	} else if (
		(initRecordData.multiValues["eta_3rd_party"].some((_id) => permissions.company_id === _id) ||
			initRecordData.multiValues["etd_3rd_party"].some((_id) => permissions.company_id === _id) ||
			initRecordData.multiValues["eta_4th_party"].some((_id) => permissions.company_id === _id) ||
			initRecordData.multiValues["etd_4th_party"].some((_id) => permissions.company_id === _id)) &&
		!initRecordData.multiValues["company_id"].some((_id) => permissions.company_id === _id)
	) {
		return <FormTransporter isAddMode={isAddMode} initRecordData={initRecordData} {...props} />;
	}
	redirect("/");
	notify("You cannot edit company and 3rd party order simultaneously", "error");
	return null;
};
